import { useContext } from "react";
import { TherapistContext } from "./TherapistContext";

export const useTherapist = () => useContext(TherapistContext);
